import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/lib/contexts/theme-context';
import { useTranslation } from 'react-i18next';

export default function DialogContact({ open, onClose }) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const supportEmail = theme.links?.supportEmail ?? 'support@horodaty.com';
    const supportPhone = theme.links?.supportPhone;

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-lg font-semibold text-foreground">{t('tokens:nousContacter')}</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-muted-foreground mb-1">{t('tokens:email')}</p>
                        <a href={`mailto:${supportEmail}`} className="text-foreground font-medium hover:underline">
                            {supportEmail}
                        </a>
                    </div>

                    {supportPhone && (
                        <div>
                            <p className="text-sm text-muted-foreground mb-1">{t('tokens:telephone')}</p>
                            <a
                                href={`tel:${supportPhone.replace(/\s/g, '')}`}
                                className="text-foreground font-medium hover:underline"
                            >
                                {supportPhone}
                            </a>
                        </div>
                    )}
                </div>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="solid" color="primary" className="w-full">
                            {t('tokens:fermer')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
